import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Tag,
  DatePicker,
  Tooltip,
  Input,
  Select,
  Avatar,
  Image,
} from "antd";
import React, { useState, useEffect, useContext } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import ShowTotal from "../../components/ShowTotal";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import useDebounce from "../../hooks/useDebounce";
import { AuthContext } from "../../context/AuthContext";
import { USERTYPE } from "../../constants/conts";
import { ExclamationCircleOutlined, UndoOutlined } from "@ant-design/icons";
import FilterBar, { FilterBarFilters } from "../../components/FilterBar";
import confirm from "antd/lib/modal/confirm";
import ViewRedemption from "./ViewReedemption";
const Search = Input.Search;
const { RangePicker } = DatePicker;

function Index() {
  const { userProfile, userPermission } = useContext(AuthContext);
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selected, setSelected] = useState();
  const [viewOpen, setViewOpen] = useState();
  const [selectedRedemption, setSelectedRedemption] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const debouncedSearchText = useDebounce(searchText, 300);
  const [filters, setFilters] = useState({ status: undefined });
  const [showFilters, setShowFilters] = useState(false);

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  // ----------- Fetch Data ---------------
  const fetchData = (pagination, filters) => {
    const params = new URLSearchParams();
    if (startDate) {
      params.append("startDate", startDate);
    }
    if (endDate) {
      params.append("endDate", endDate);
    }
    if (debouncedSearchText) {
      params.append("search", debouncedSearchText);
    }

    request({
      url: `${apiPath.listRedemption}?${params.toString()}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(() => data?.data);
        setPagination((prev) => ({
          current: pagination?.page,
          total: data?.total,
          pageSize: Number(data?.limit),
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };
  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };
  const resetData = () => {
    setSearchText("");
    setStartDate("");
    setEndDate("");
    setRefresh((prev) => !prev);
  };
  const confirmStatus = (id) => {
    setTimeout(() => {
      confirm({
        maskClosable: true,
        icon: <ExclamationCircleOutlined />,
        className: "tab_modal",
        cancelButtonProps: { color: "red" },
        content: (
          <p
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Are you sure you want delete this reward ?
          </p>
        ),
        onOk() {
          request({
            url: `${apiPath.deleteReward}/${id}`,
            method: "PUT",
            onSuccess: (data) => {
              fetchData(pagination, filters);
              ShowToast(
                data.message || "Reward Deleted Successfully",
                Severty.SUCCESS,
              );
            },
            onError: (error) => {
              setLoading(false);
              ShowToast(error, Severty.ERROR);
            },
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };
  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({ ...prev, [filterName]: value }));
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const columns = [
    {
      title: "Reedemed By",
      dataIndex: "user",
      key: "user",
      width: "25%",
      render: (user = {}) => {
        const { name, avatar, _id } = user;

        const capitalizedName = name
          ? name.charAt(0).toUpperCase() + name.slice(1)
          : "Not Available";

        return (
          <>
            {!avatar ? (
              <Avatar size={40}>{name ? name.charAt(0) : "N/A"}</Avatar>
            ) : (
              <Image className="image-index-radius" src={avatar} />
            )}
            <a className="avatar-text">{capitalizedName}</a>
          </>
        );
      },
    },
    {
      title: "Reddemed Reward",
      dataIndex: ["reward", "name"],
      width: "25%",
      render: (name) => name,
    },
    {
      title: "Reward Point",
      dataIndex: ["reward", "pointsRequired"],
      width: "25%",
      render: (pointsRequired) => pointsRequired,
    },
    {
      title: "Reedemed Point",
      dataIndex: "pointsUsed",
      width: "25%",
      render: (pointsUsed) => pointsUsed,
    },
    {
      title: `Redeemed Date`,
      key: "redeemedAt",
      dataIndex: "redeemedAt",
      width: "25%",
      render: (text) => moment(text).format("DD-MM-YYYY"),
    },
    {
      title: `${lang("Action")}`,

      render: (_, record) => {
        return (
          <>
            <Tooltip
              title="View Reedemption"
              color={"purple"}
              key={"viewReedemption"}
            >
              <Button
                onClick={() => {
                  setSelectedRedemption(record);
                  setViewOpen(true);
                }}
              >
                <i className="fa fa-light fa-eye"></i>
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleChangeDate = (e) => {
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };

  // ----------- Use Effects ----------
  useEffect(() => {
    setLoading(true);
    fetchData(pagination, filters);
  }, [filters, refresh, startDate, endDate, debouncedSearchText]);

  return (
    <>
      <div className="tabled">
        <ViewRedemption
          open={viewOpen}
          onClose={() => setViewOpen(false)}
          redemption={selectedRedemption}
        />

        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={`Reward Manager`}
              extra={
                <FilterBar
                  showFilters={showFilters}
                  onToggle={() => setShowFilters((v) => !v)}
                  searchContent={
                    <Search
                      size="large"
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      allowClear
                      placeholder="Search by name"
                    />
                  }
                />
              }
            >
              {showFilters && (
                <FilterBarFilters>
                  <RangePicker
                    onChange={handleChangeDate}
                    value={
                      startDate && endDate
                        ? [moment(startDate), moment(endDate)]
                        : null
                    }
                  />
                  <Button
                    onClick={() => resetData()}
                    type="primary"
                    icon={<UndoOutlined />}
                  >
                    Reset
                  </Button>
                </FilterBarFilters>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  marginBottom: "10px",
                  flexWrap: "wrap",
                }}
              >
                <h4 className="text-right m-0">
                  {" "}
                  {pagination.total
                    ? ShowTotal(pagination.total)
                    : ShowTotal(0)}{" "}
                </h4>
              </div>

              <div className="table-responsive customPagination customPaginationmain-newwwww">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Index;
